import Vue from 'vue'
import VueRouter from 'vue-router'
import CollectesView from '../views/CollectesView'
import Collecte from '../components/collecte/Collecte'
import Objectif from '../components/collecte/Objectif'

Vue.use(VueRouter)

const routes = [
    {
        path: "/faire-un-don",
        name: "FormulaireDon",
        component: () => import('../views/FormulaireDon.vue'),
    },
    {
        path: "/faire-un-don/in-honoriam",
        name: "FormulaireDonInHonoriam",
        component: () => import('../views/FormulaireDon.vue'),
    },
    {
        path: "/faire-un-don/in-memoriam",
        name: "FormulaireDonInMemoriam",
        component: () => import('../views/FormulaireDon.vue'),
    },
    {
        path: "/remerciement-don",
        name: "RemerciementDon",
        component: () => import('../views/RemerciementDon.vue'),
    },
    {
        path: "/remerciement-don-mensuel",
        name: "RemerciementDonMensuel",
        component: () => import('../views/RemerciementDonMensuel.vue'),
    },
    {
        path: "/formulaire-adhesion",
        name: "FormulaireAdhesion",
        component: () => import('../views/FormulaireAdhesion.vue'),
        redirect: { name: "FormulaireAdhesionPersonneToucheeParLeDiabete" },
        children: [
            {
                path: 'professionnel-de-la-sante',
                name: "FormulaireAdhesionProfessionnelDeLaSante",
            },
            {
                path: 'personne-touchee-par-le-diabete',
                name: "FormulaireAdhesionPersonneToucheeParLeDiabete",
            }
        ]
    },
    {
        path: "/remerciement-adhesion",
        name: "RemerciementAdhesion",
        component: () => import('../views/RemerciementAdhesion.vue'),
        props: true
    },
    {
        path: '/boutique',
        name: "Boutique",
        component: () => import('../views/Boutique/Boutique.vue'),
        redirect: { name: "Produits" },
        children: [
            {
                path: 'produits',
                name: "Produits",
                component: () => import('../views/Boutique/Produits.vue'),
            },
            {
                path: 'produit/:id',
                name: "Produit",
                component: () => import('../views/Boutique/Produit.vue'),
                props: true
            },
            {
                path: 'caisse',
                name: "Caisse",
                component: () => import('../views/Boutique/Caisse.vue'),
                props: {
                    hidePanierDrawer: true
                }
            }
        ]
    },
    {
        path: "/erreur-paiement",
        name: "ErreurPaiement",
        component: () => import('../views/ErreurPaiement.vue'),
    },
    {
        path: "/erreur-collecte",
        name: "ErreurCollecte",
        component: () => import('../views/ErreurCollecte.vue'),
    },
    {
        path: '/collecte',
        component: CollectesView,
        children: [
            {
                path: ':identifiantCollecte',
                name: 'Collecte',
                component: Collecte,
            },
            {
                path: ':identifiantCollecte/participant/:identifiantObjectif',
                name: 'Objectif',
                component: Objectif
            },
        ]

    },
    {
        path: "/revues-plein-soleil",
        name: "RevuesPleinSoleil",
        component: () => import('../views/Extranet/RevuesPleinSoleil.vue'),
    },
]

const router = new VueRouter({
    routes
})

router.afterEach(() => {
    window.scrollTo(0, 0);
})

export default router
